import { VariantProps, cva } from "class-variance-authority";
import { Container } from "../Container";
import { ReactNode } from "react";
import { Flock } from "../flock/flock";
import { twMerge } from "tailwind-merge";

export interface FlockCompositionProps
    extends VariantProps<typeof FlockCompositionStyles> {
    composition?: "default" | "footer" | "home";
    children?: ReactNode;
    className?: string;
}

export const FlockCompositionStyles = cva("overflow-hidden");
export const FlockComposition = ({
    composition = "default",
    className,
    children,
}: FlockCompositionProps): JSX.Element => {
    return (
        <div
            className={twMerge(
                FlockCompositionStyles({
                    className,
                }),
            )}
        >
            {composition === "footer" ? (
                <Container className="relative z-10">
                    <Flock className="top-[50px] right-[430px] w-[170px] translate-x-[100%] -rotate-45 lg:hidden" />
                </Container>
            ) : composition === "home" ? (
                <Container className="relative z-10">
                    {/* Left */}
                    <Flock className="top-[2px] left-[42px] w-[152px] -rotate-45 hidden xl:block" />
                    <Flock className="top-[236px] left-[-75px] w-[44px] -rotate-45 hidden xl:block" />
                    <Flock className="top-[96px] left-[-149px] w-[554px] -rotate-45 hidden xl:block" />
                    {/* Right */}
                    <Flock className="top-[96px] right-[45px] w-[175px] translate-x-[100%] hidden xl:block" />
                    <Flock className="top-[6px] right-[90px] w-[75px] translate-x-[100%] lg:hidden" />
                    <Flock className="top-[353px] right-[-107px] w-[462px] translate-x-[100%] -rotate-45 hidden xl:block" />
                </Container>
            ) : (
                <Container className="relative hidden xl:block z-10">
                    {/* Left */}
                    <Flock className="top-[82px] left-[-62px] w-[139px] -rotate-45" />
                    <Flock className="top-[278px] left-[38px] w-[77px] -rotate-45" />
                    <Flock className="top-[168px] left-[-185px] w-[508px] -rotate-45" />
                    {/* Right */}
                    <Flock className="top-[343px] right-[-113px] w-[325px] translate-x-[100%] -rotate-45" />
                </Container>
            )}

            <div className="relative z-20">{children}</div>
        </div>
    );
};
